"use strict";

exports.__esModule = true;
exports["default"] = backgroundImages;

function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/shorthands/backgroundImages.js
// module id = 1036
// module chunks = 27180705640166